import bowser from 'bowser'

const browser = bowser.getParser(window.navigator.userAgent)

export const IS_IOS = browser.getOS().name === 'iOS'
export const IS_ANDROID = browser.getOS().name === 'Android'
export const IS_SAFARI = browser.getBrowserName() === 'Safari'
export const IS_IOS_SAFARI = browser.getOS().name === 'iOS' && browser.getBrowserName() === 'Safari'

export default null